import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { logout } from '../../../reducer/authSlice'
import { useLogout } from '../../../api/auth/hooks'
import styled from 'styled-components'
import Loading from '../../organisms/Loading'

const Logout = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { mutate: doLogout } = useLogout()

  useEffect(() => {
    doLogout(
      {},
      {
        onSuccess: (data) => {
          if (data.code === 0) {
            console.log("@Logout Success")
          }
        },
        onError: (error) => {
          console.error("@Logout failed", error)
        },
        onSettled: () => {
          dispatch(logout())
          navigate("/")
        }
      }
    )
  }, [logout, dispatch, navigate])

  return (
    <FullScreen>
      <Loading />
    </FullScreen>
  )
}

const FullScreen = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255,255,255,0.7);
  z-index: 9999;
`

export default Logout